import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../components/context/LoginContext/AuthContext";

/**
 * @typedef {Object} School
 * @property {number} id
 * @property {string} name
 * @property {string|null} image_url
 */

/**
 * Admin - Get All Schools for Agreement
 */
export const useGetAgreementSchoolList = () => {
  const { user, fetchWithAuth } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  /** @type {[School[], Function]} */
  const [schools, setSchools] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSchools = useCallback(async () => {
    if (!user?.token) return;

    setLoading(true);
    setError(null);

    try {
      const response = await fetchWithAuth(`${apiUrl}/references/schools`, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Failed to fetch schools");
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message || "Failed to fetch schools");
      }

      // API response mapping
      setSchools(result.data || []);
      setMeta(result.meta || null);
    } catch (err) {
      console.error("School List Fetch Error:", err);
      setError(err.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  }, [apiUrl, fetchWithAuth, user]);

  useEffect(() => {
    fetchSchools();
  }, [fetchSchools]);

  return {
    schools,
    meta,
    loading,
    error,
    refetch: fetchSchools,
  };
};
